import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'custom-dropdown',
    templateUrl: './custom-dropdown.component.html',
    styleUrls: ['./custom-dropdown.component.scss'],
    standalone: false
})
export class CustomDropdownComponent<T> {
  @Input() width = '226px';
  @Input() backgroundTone: 'light' | 'regular' = 'regular';
  @Input() items: T[] = [];

  @Input() selectedItem: T | null = null;
  @Output() selectedItemChange: EventEmitter<T> = new EventEmitter<T>();

  @Input() getItemLabel: (item: T) => string = (item: T) => String(item);

  isDropdownOpen = false;

  selectItem(item: T): void {
    this.selectedItem = item;
    this.selectedItemChange.emit(this.selectedItem);
    this.isDropdownOpen = false;
  }
}
